function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.39896 5.98985L3.22239 3.81323C1.25155 5.91808 0.107319 8.66379 0 11.5449H3.07967C3.18377 9.47984 4.00391 7.51567 5.39896 5.98985Z",
  fill: "#7C8288"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.04553 5.3487C7.56382 3.98407 9.50499 3.18306 11.5437 3.08016V0C8.68849 0.106333 5.9659 1.23123 3.86792 3.17083L6.04553 5.3487Z",
  fill: "#7C8288"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.37314 17.9822C3.9935 16.4601 3.18314 14.5072 3.07967 12.4553H0C0.106939 15.3236 1.2414 18.0577 3.19636 20.1594L5.37314 17.9822Z",
  fill: "#7C8288"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.456 3.08016C14.5078 3.18365 16.4607 3.99406 17.9828 5.37389L20.1598 3.19685C18.0584 1.24164 15.3242 0.106957 12.4559 0L12.456 3.08016Z",
  fill: "#7C8288"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9187 11.5446H23.9983C23.8916 8.67635 22.7569 5.94225 20.802 3.84058L18.625 6.01761C20.0048 7.53979 20.8152 9.49281 20.9187 11.5445V11.5446Z",
  fill: "#7C8288"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9983 20.0208C16.4209 20.0208 20.0187 16.423 20.0187 11.9998C20.0187 7.57695 16.4208 3.97876 11.9983 3.97876C7.57593 3.97876 3.97803 7.57716 3.97803 11.9998C3.97803 16.4224 7.57593 20.0203 11.9983 20.0203V20.0208ZM9.4066 9.68003V9.65888C9.4066 8.73301 9.90063 7.8773 10.7024 7.41434C11.5045 6.9512 12.4924 6.9512 13.2944 7.41434C14.0962 7.87728 14.5902 8.73301 14.5902 9.65888V9.68003C15.385 9.74 16.1079 10.1623 16.5505 10.8249C16.9931 11.4876 17.1064 12.3172 16.8575 13.0743C16.6084 13.8314 16.0252 14.4318 15.2756 14.7026C14.526 14.9732 13.6936 14.8842 13.0185 14.4607C12.9884 14.6127 12.9748 14.7675 12.9776 14.9224C12.9776 15.4514 13.2075 16.0166 13.853 16.0166C14.1114 16.0166 14.321 16.2262 14.321 16.4846C14.321 16.743 14.1114 16.9526 13.853 16.9526H10.1437C9.88488 16.9526 9.67507 16.7428 9.67507 16.484C9.67507 16.2252 9.88488 16.0156 10.1437 16.0156C10.7892 16.0156 11.0191 15.4506 11.0191 14.9219V14.9217C11.022 14.767 11.0083 14.6125 10.9784 14.4606C10.3032 14.8839 9.47093 14.9732 8.72136 14.7024C7.972 14.4318 7.38851 13.8314 7.13962 13.0743C6.89078 12.3173 7.00381 11.4879 7.44641 10.825C7.889 10.1625 8.61177 9.74016 9.40647 9.6802L9.4066 9.68003Z",
  fill: "#7C8288"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4541 23.9999C15.3353 23.8926 18.0808 22.7481 20.1856 20.7774L18.009 18.6008C16.483 19.996 14.5188 20.8159 12.4541 20.92V23.9999Z",
  fill: "#7C8288"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5431 23.9999V20.9202C9.49136 20.8167 7.53864 20.0063 6.01634 18.6265L3.83936 20.8035C5.94072 22.7587 8.67476 23.8932 11.5432 23.9999H11.5431Z",
  fill: "#7C8288"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9199 12.4556C20.817 14.4944 20.016 16.4356 18.6514 17.9538L20.8292 20.1315C22.7687 18.0335 23.8936 15.3108 23.9999 12.4556H20.9199Z",
  fill: "#7C8288"
});

const SvgVirtualCasino = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVirtualCasino, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/virtual-casino.88e06619.svg";
export { ForwardRef as ReactComponent };